













import { IWorkflowFormTemplateRevision } from '@/models';

import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'WorkflowFormBuilderStatusDisplay',

  props: {
    formTemplate: {
      type: Object as PropType<IWorkflowFormTemplateRevision>,
      required: true
    }
  }
});
